import newCallSound from "../assets/new-call.mp3";

let audioUnlocked = false;

export function unlockNotificationAudio() {
  audioUnlocked = true;
}

export function isNotificationAudioUnlocked() {
  return audioUnlocked;
}

/** Bip curto via Web Audio (não exige segundo arquivo). */
export function playSoftMessageBeep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 880;
    gain.gain.value = 0.08;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.12);
    osc.onended = () => {
      try {
        ctx.close();
      } catch {
        /* ignore */
      }
    };
  } catch {
    /* ignore */
  }
}

export function playMp3Url(url, volume = 1) {
  if (!url) return;
  try {
    const audio = new Audio(url);
    audio.volume = Math.min(1, Math.max(0, volume));
    audio.play().catch(() => {});
  } catch {
    /* ignore */
  }
}

export function getRequestAlertSoundUrl() {
  return newCallSound;
}
